import { useState } from "react";
import styles from "./language-selection.module.less";
import { useTranslation } from "react-i18next";
import { TLanguage, TLanguageLink } from "../../../../../types/language-types";
import LanguageModal from "../../../../elements/language-modal/language-modal";
import Flag from "../../../../elements/flag/flag";
import { HeaderButton } from "../header-button/header-button";

export type TLanguageSelectionProps = {
  currentLanguage: TLanguage;
  languages: Array<TLanguageLink>;
  className?: string;
  hideMobile?: boolean;
  noSeparator?: boolean;
};

const LanguageSelection = ({
  currentLanguage,
  languages,
  className,
  hideMobile,
  noSeparator,
}: TLanguageSelectionProps) => {
  const [displayLanguageModal, setDisplayLanguageModal] = useState(false);
  const { t } = useTranslation();
  const portalContainer =
    typeof window !== "undefined" ? document.getElementById("languageSelectionPortalWrapper") : null;

  return (
    <div className={[styles.wrapper, className ?? ""].join(" ")}>
      <HeaderButton
        noSeparator={noSeparator}
        hideMobile={hideMobile}
        isActive={displayLanguageModal}
        onClick={() => setDisplayLanguageModal(true)}
        ariaLabel={t("HEADER_LANGUAGE_SELECTION_ARIA_LABEL")}
      >
        <Flag country={currentLanguage} />
        <div className={[styles.languageText, "body-s"].join(" ")}>
          {/*//@ts-ignore */}
          {t("LANGUAGE_" + currentLanguage.toUpperCase())}
        </div>
      </HeaderButton>
      <LanguageModal
        isOpen={displayLanguageModal}
        currentLanguage={currentLanguage}
        languages={languages}
        portalContainer={portalContainer}
        close={{
          function: () => setDisplayLanguageModal(false),
        }}
      />
    </div>
  );
};

export default LanguageSelection;
